/**
 * An advanced search upsell used on the Header's search bar.
 * Fades in/out when show prop is changed.
 * If user is already premium, links to adv search page.
 *
 * TODO: should the premium version still link to adv search?
 *   I thought we killed that and the adv search upgrade page
 */
import React from 'react';
import styled from 'astroturf/react';
import { CSSTransition } from 'react-transition-group';

import { currentUser } from 'js/utils/user';
import routes from 'sitewide-js/core_pre_webpack/routes';
import _Title from "SearchUpsell-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/SearchUpsell.tsx?styleId=Title";
import _Body from "SearchUpsell-Body.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/SearchUpsell.tsx?styleId=Body";
import _CtaButton from "SearchUpsell-CtaButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/SearchUpsell.tsx?styleId=CtaButton";


const Title = /*#__PURE__*/styled("div", null, {
  displayName: "Title",
  styles: _Title
});

const Body = /*#__PURE__*/styled("div", null, {
  displayName: "Body",
  styles: _Body
});

const CtaButton = /*#__PURE__*/styled("button", null, {
  displayName: "CtaButton",
  styles: _CtaButton
});

type Props = {
  show: boolean;
};

const SearchUpsell = ({ show }: Props) => {
  return (
    <CSSTransition
      in={show}
      timeout={300}
      className="search-bar-upsell-container"
    >
      <div>
        <Title>ACADEMIA PREMIUM FEATURE</Title>
        <Body>Search the full text of over 47 million papers on Academia.</Body>
        {currentUser?.premium ? (
          <CtaButton
            as="a"
            href={routes.advanced_search_path({
              feature: 'search',
              trigger: 'search-popover',
              from_navbar: true,
            })}
          >
            Start Advanced Search
          </CtaButton>
        ) : (
          <CtaButton
            as="a"
            href={routes.upgrade_path({
              feature: 'search',
              trigger: 'search-popover',
              from_navbar: true,
            })}
          >
            Learn More
          </CtaButton>
        )}
      </div>
    </CSSTransition>
  );
};

export default SearchUpsell;
